import * as React from "react";
import { Callout } from "@blueprintjs/core";
import { css } from "@emotion/core";

export function ReadOnlyNotice(props: { children: React.ReactNode }) {
  return (
    <Callout
      intent="primary"
      icon="lock"
      css={css`
        border-radius: 0;
      `}
    >
      These settings are read-only. {props.children} Contact us for details and
      feedback.
    </Callout>
  );
}
